import { PROFILES } from "./data/profiles";
import { useRegister } from "./RegisterContext";
import registerlg from "../../Assets/carrerup_profile_NoBg.png"
import { useTranslation } from "react-i18next";

export default function RegisterStep1() {
  const { step, profile, setProfile, next, resetRegister } = useRegister();

  const { t } = useTranslation();

  if (step !== 1) return null;

  return (
    <div className="register-step register-animate">
      <div className='flexed_logo_title'>
        <img src={registerlg} width={40} />
        <h2>{t("registerStep1.title")}</h2>
      </div>

      <div className="register-profile-grid">
        {PROFILES.map((p) => (
          <button
            type='button'
            key={p.id}
            className={profile === p.id ? "active" : ""}
            onClick={() => {
              resetRegister();
              setProfile(p.id);
            }}

          >
            {t(p.label)}
          </button>
        ))}
      </div>

      <button
        type='button'
        className="register-primary-btn"
        disabled={!profile}
        onClick={next}
      >
        {t("registerStep1.next")}
      </button>
      <a href='/login'>
        {t("registerStep1.alreadyRegistered")}
      </a>
    </div>
  );
}
